import React, { Component } from 'react';
import { Provider } from 'react-redux';
import styled from 'styled-components';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import './fonts/icomoon/style.css';
import Navbar from './components/Navbar';
import store from './store';
import Home from './routes/Home';
import ForSale from './routes/ForSale';
import ForRent from './routes/ForRent';
import Draft from './routes/Draft';
import Turism from './routes/Turism';
import Section from './routes/Section';
import Contact from './routes/Contact';
import Footer from './components/Footer';

const BodyContainer = styled.div`
  background-color: black;
  min-height: 100vh;
  width: 100%;
  position: relative;
  z-index: 0;
`;

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <BodyContainer>
          <Router>
            <div>
              <Navbar />
              <Switch>
                <Route path="/" component={Home} exact />
                <Route path="/propiedades-venta" component={ForSale} />
                <Route path="/propiedades-arriendo" component={ForRent} />
                <Route path="/proyectos" component={Draft} />
                <Route path="/turismo" component={Turism} />
                <Route path="/contactenos" component={Contact} />
                <Route path="/seccion/:permalink" component={Section} />
              </Switch>
              <Footer />
            </div>
          </Router>
        </BodyContainer>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js